module.exports = __webpack_public_path__ + "static/media/kawari-logo-uat.023ba257.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/kawari-logo-uat.svg
// module id = 411
// module chunks = 0